import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./index.module.css";
import { Form, Card, InputGroup, FormControl, Alert } from "react-bootstrap";
import { Action as AuthAction } from "../../store/auth";
import { Request } from "../../store/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

const Signup = () => {
  const [data, setData] = useState({ username: "", name: "" });
  const [success, setSuccess] = useState(false);
  const [validated, setValidated] = useState(false);

  const loading = useSelector((state) => state.ui.loading[Request.AUTH_SIGNUP]);
  const error = useSelector((state) => state.ui.error[Request.AUTH_SIGNUP]);
  const dispatch = useDispatch();

  const changeHandler = ({ target }) => {
    const { name, value } = target;
    setData({ ...data, [name]: value });
  };

  const submit = async (e) => {
    e.preventDefault();
    setValidated(true);
    setSuccess(false);
    if (e.target.checkValidity()) {
      const response = await dispatch(AuthAction.signup(data));
      if (response) setSuccess(true);
    }
  };

  return (
    <div className={classes.Login}>
      <div className={classes.FormContainer}>
        <Card>
          <Card.Header>
            <FontAwesomeIcon icon="user" />
            <span className="ml-3">Signup</span>
          </Card.Header>
          <Card.Body>
            <Form noValidate onSubmit={submit} validated={validated}>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text className="input-group-text">
                    <FontAwesomeIcon icon="user" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl type="text" placeholder="Name" name="name" value={data.name} required onChange={changeHandler} />
                <Form.Control.Feedback type="invalid">Please enter name</Form.Control.Feedback>
              </InputGroup>
              <InputGroup className="mb-3">
                <InputGroup.Prepend>
                  <InputGroup.Text className="input-group-text">
                    <FontAwesomeIcon icon="at" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl type="text" placeholder="E-mail" name="email" value={data.email} required onChange={changeHandler} />
                <Form.Control.Feedback type="invalid">Please enter email</Form.Control.Feedback>
              </InputGroup>
              <button type="submit" className="btn btn-outline-primary btn-block" disabled={loading}>
                Signup
              </button>
              <div className="text-right my-3">
                <Link to="/login">Login</Link>
              </div>
              {error && (
                <Alert variant="danger" className="mt-3">
                  {error}
                </Alert>
              )}
              {success && (
                <Alert variant="success" className="mt-3">
                  Success! You should receive e-mail with further instructions.
                </Alert>
              )}
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Signup;
